import React from 'react';

import { ImmutableMapItem, PionType } from '../../type';
import CardItem from '../EntityWrapper';

export type CardPionPropsType = {
  pion: Pick<PionType, keyof ImmutableMapItem | 'cardReference'>;
};

const CardPion = ({ pion }: CardPionPropsType) => {
  const imageUrl =
    pion.getIn(['cardReference', 'image', 'smallUrl']) ||
    pion.getIn(['cardReference', 'placeholderImageSvg']);
  return (
    <CardItem
      image={imageUrl}
      title={pion.getIn(['cardReference', 'title'])}
      tags={pion.getIn(['cardReference', 'tags'])}
      backgroundColor={pion.getIn(['cardReference', 'backgroundColor'])}
    />
  );
};

export default CardPion;
